import { useEffect, useRef } from "react";
import facebook_icon from "../../assets/images/svg/facebook_icon.svg";
import youtub_icon from "../../assets/images/svg/youtub_icon.svg";
// import insta_icon from "../../assets/images/svg/insta_icon.svg";
import insta_icon from "../../assets/images/png/insta_icon.png";
// import msg_icon from "../../assets/images/svg/msg_icon.svg";
// import right_icon from "../../assets/images/svg/right_icon.svg";
import footer from '../../assets/images/footer/footer.jpg';
import { Link } from "react-router-dom";

const Footer = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          element.classList.add("footer-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div
      ref={sectionRef}
      className="footer_bg pt-md-5 pt-4 position-relative overflow-hidden"
    >
      <div
        className="footer-photo"
        style={{ backgroundImage: `url(${footer})` }}
      />
      <div className="footer-photo-scrim" />
      <div className="container position-relative" style={{ zIndex: 2 }}>
        <div className="footer-content">
        <div className="row justify-content-between g-4">
          <div className="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4 footer-reveal footer-reveal-d1">
            <h4 className=" fs_18 ff_s fw-bold text-white mb-0">Contact Us</h4>
            <p className=" fs_n ff_n fs_14 text-gray-300 mt-3 mb-3">
              Plot no. 251, Phase 4,
              <br className="d-lg-block d-none"></br> Udyog Vihar, Sector 18,
              Gurugram, Haryana 122015
            </p>
            <a
              href="mailTo:support@hkimedia.com"
              className="fs_16 mb-0  fw-bold mt-3 ff_n text-white"
            >
              <span className=" clr_theme">Mail :</span> Support@hkimedia.com
            </a>
          </div>

          <div className="col-lg-2 col-md-6 col-sm-6 mt-lg-0 mt-4 footer-reveal footer-reveal-d2">
            <h4 className=" fs_18 ff_s fw-bold text-white mb-0">
              Important Links
            </h4>

            <ul className="ps-0 mt-2">
              <li className="mt-2">
                <Link to="/" className="fs_14 fw-normal ff_n text-gray-300">
                  Home
                </Link>
              </li>

              { <li className="mt-2">
                <Link
                  to="/hki-animatica#faq"
                  className="fs_14 fw-normal ff_n text-gray-300"
                >
                  Help(FAQ)
                </Link>
              </li> }

              <li className="mt-2">
                <Link
                  to="/contact-us"
                  className="fs_14 fw-normal ff_n text-gray-300"
                  onClick={scrollToTop}
                >
                  Contact
                </Link>
              </li>
              <li className="mt-2">
                <Link
                  to="/news"
                  className="fs_14 fw-normal ff_n text-gray-300"
                  onClick={scrollToTop}
                >
                  News
                </Link>
              </li>
               <li className="mt-2">
                <Link
                  to="/blogs"
                  className="fs_14 fw-normal ff_n text-gray-300"
                  onClick={scrollToTop}
                >
                  Blogs
                </Link>
              </li>

              {/* <li className="mt-2">
                <Link
                  to="/gigmatic-studios"
                  className="fs_14 fw-normal ff_n text-gray-300"
                  onClick={scrollToTop}
                >
                  Gigmatic Studios
                </Link>
              </li> */}
            </ul>
          </div>

          {/* <div className="col-lg-3 col-md-6 mt-4 mt-lg-0 footer-reveal footer-reveal-d3">
            <h4 className=" fs_18 ff_s fw-bold text-white mb-0">Newsletter</h4>
            <p className=" fs_n ff_n fs_14 text-gray-300 mt-3 mb-0">
              Subscribe to HKI Magazine to stay on top of Media Scenes
            </p>
            <div className="footer-newsletter-group mt-3">
              <input
                className="footer-newsletter-input"
                type="text"
                placeholder="Enter Your Email"
              />
              <button className="footer-newsletter-btn">
                <img loading="lazy" decoding="async" width={18} height={18} src={msg_icon} alt="msg_icon" />
              </button>
            </div>
            <p
              style={{ cursor: "pointer" }}
              className=" fs_14 ff_s fw-bold mt-3 mb-0 clr_theme"
            >
              Subscribe Now &nbsp;
              <img loading="lazy" decoding="async" src={right_icon} alt="right_icon" />
            </p>
          </div> */}

          <div className="col-lg-3 col-md-6 mt-4 mt-lg-0 footer-reveal footer-reveal-d4">
            <h4 className=" fs_18 ff_s fw-bold text-white mb-0">Follow Us</h4>
            <div className="d-flex align-items-center gap-2 mt-4">
              <a
                className="footer-social-icon"
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/profile.php?id=61571039155522"
              >
                <img loading="lazy" decoding="async" src={facebook_icon} alt="facebook_icon" />
              </a>
              <a
                className="footer-social-icon"
                target="_blank"
                rel="noreferrer"
                href="https://www.instagram.com/hkiofficial?igsh=MWFnZW4zbTE5cml3YQ=="
              >
                <img loading="lazy" decoding="async" className="insta-icon" src={insta_icon} alt="insta_icon" />
              </a>
              <a
                className="footer-social-icon"
                target="_blank"
                rel="noreferrer"
                href="https://www.youtube.com/@Hki_music"
              >
                <img loading="lazy" decoding="async" src={youtub_icon} alt="youtube_icon" />
              </a>
            </div>
          </div>
        </div>

        <div
          className="footer-divider footer-reveal footer-reveal-d5 mt-5 mb-3"
          style={{ border: "0.83px solid" }}
        ></div>

        <div className="footer-reveal footer-reveal-d5 d-md-flex text-center text-md-start pb-3 justify-content-between align-items-center">
          <p className="fs_14 mb-0  fw-bolder text-white ff_n">
            © <strong className="clr_theme">HKI Media Pvt. Ltd. 2025</strong> –{" "}
            <em>Crafted with Creativity, Powered by People.</em>
          </p>
          <div className="d-flex align-items-center justify-content-center justify-content-md-start mt-2 mt-md-0 gap-3">
            {/* <a className="p-0 fs_14 ff_n clr_darkgray" href="#">
              Terms of Use
            </a> */}
            <Link
              to="/privacy-policy"
              className="p-0 fs_14 ff_n text-white"
              onClick={scrollToTop}
            >
              Privacy Policy
            </Link>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
